import { render, staticRenderFns } from "./CopyItem.vue?vue&type=template&id=ed0d0982&scoped=true&"
import script from "./CopyItem.vue?vue&type=script&lang=js&"
export * from "./CopyItem.vue?vue&type=script&lang=js&"
import style0 from "./CopyItem.vue?vue&type=style&index=0&id=ed0d0982&prod&scoped=true&lang=css&"
import style1 from "./CopyItem.vue?vue&type=style&index=1&id=ed0d0982&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0d0982",
  null
  
)

export default component.exports